<template>
  <t-form
    :requiredMark="option.attribute.required"
    :labelAlign="option.attribute.labelAlign"
    :style="setStyles"
  >
    <t-form-item
      :label="option.attribute.label"
      class="my_date_picker"
      :style="setStyles"
    >
      <div v-if="option.attribute.daterange" class="my_data_range_item">
        <m-cell class="my_date_picker_item" @click="visible = true">
          <template #note>
            <div :class="{ white: checkedValDate[0] }">
              {{ checkedValDate[0] || option.attribute.placeholder }}
            </div>
          </template>
        </m-cell>
        -
        <m-cell class="my_date_picker_item" @click="visible = true">
          <template #note>
            <div :class="{ white: checkedValDate[1] }">
              {{ checkedValDate[1] || option.attribute.placeholder }}
            </div>
          </template>
        </m-cell>
        <div><t-icon style="font-size: 16px" name="calendar" /></div>
      </div>
      <template v-else>
        <m-cell class="my_date_picker_item" @click="visible = true">
          <template #rightIcon>
            <t-icon style="font-size: 16px" name="calendar" />
          </template>
          <template #note>
            <div :class="{ white: checkedVal }">
              {{ checkedVal || "请选择" }}
            </div>
          </template>
        </m-cell>
      </template>
    </t-form-item>
  </t-form>
  <m-popup v-model="visible" placement="bottom" :style="setStyles">
    <template v-if="option.attribute.daterange">
      <div class="my_toolbar">
        <div class="t-picker__cancel" @click="visible = false">取消</div>
        <div class="t-picker__title my_data_range">
          <m-cell
            :class="{ my_data_range_cell: true, active: active == 1 }"
            @click="cellClick(1)"
          >
            <template #note>
              <div :class="{ white: daterangeData[0] }">
                {{ daterangeData[0] || option.attribute.placeholder }}
              </div>
            </template>
          </m-cell>
          -
          <m-cell
            :class="{ my_data_range_cell: true, active: active == 2 }"
            @click="cellClick(2)"
          >
            <template #note>
              <div :class="{ white: daterangeData[1] }">
                {{ daterangeData[1] || option.attribute.placeholder }}
              </div>
            </template>
          </m-cell>
          <div><t-icon style="font-size: 16px" name="calendar" /></div>
        </div>
        <div class="t-picker__confirm" @click="confirm">确定</div>
      </div>
      <m-date-time-picker
        ref="picker"
        :value="pickerValueText"
        :mode="formatMode(option.attribute.dateFormat)"
        class="my_daterange"
        start="1970-01-01"
        end="2100-01-01"
        :format="formatD(option.attribute.dateFormat)"
        @confirm="handleConfirm"
        @cancel="onCancel"
        @pick="onChange"
      />
    </template>
    <template v-else>
      <m-date-time-picker
        :value="pickerValueText"
        :mode="formatMode(option.attribute.dateFormat)"
        :title="option.attribute.placeholder"
        start="1970-01-01"
        end="2100-01-01"
        :format="formatD(option.attribute.dateFormat)"
        @confirm="clickHandler"
        @cancel="onCancel"
      />
    </template>
  </m-popup>
</template>

<script>
import {
  getDataJson,
  pollingRefresh,
  hasNonEmptyValues,
  hasProperty,
} from "@/utils/refresh-cpt-data";
import { getDefaultValue } from "@/utils/refresh-cpt-data"; // 默认值方法


import {
  DateTimePicker as MDateTimePicker,
  Cell as MCell,
  Popup as MPopup,
} from "tdesign-mobile-vue";
// Message as MobileMessage,
// 引入组件库的少量全局样式变量
import 'tdesign-mobile-vue/es/style/index.css';


// import { mixinsCom } from "@/mixins/globalAllComps";

export default {
  name: "cpt-date-picker-mobile",
  props: {
    option: Object,
    refMap: Object,
    current: Object,
  },
  // mixins: [mixinsCom], 
  data() {
    return {
      checkedVal: "",
      daterange: false, //日期范围开关
      checkedValDate: [],
      daterangeData: [],
      message: "default",
      tips: "",
      uuid: null,
      visible: false,
      pickerValueText: new Date().toISOString().slice(0, 10),
      active: 1,
    };
  },
  components: {
    "m-date-time-picker": MDateTimePicker,
    "m-cell": MCell,
    "m-popup": MPopup,
  },
  watch: {
    'option.attribute.dateFormat': {
      handler(val) {
        this.formatDefaultValue(val)
      },
      immediate: true
    }

  },
  // watch: {
  //   //监控日期范围
  //   'option.attribute': {
  //     handler(obj) {
  //       this.daterange = obj.daterange;
  //       const defaultValue = getDefaultValue(obj, 'cpt-date-picker');
  //       if (defaultValue) {
  //         console.log(defaultValue, 'defaultValue')
  //         let str;
  //         if (Array.isArray(defaultValue)) {
  //           // 转换数组元素
  //           str = defaultValue.map(item => typeof item == 'undefined' ? item : String(item));
  //           console.log(str); // 输出: ["2024", undefined]
  //         }
  //         obj.daterange ? this.checkedValDate = str : this.checkedVal = defaultValue.toString();
  //       }
  //     },
  //     deep: true
  //   },
  // },
  watch: {
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  computed: {
    
    setStyles() {
      return {
        "--width": this.current.cptWidth + "px",
        "--height": this.option.attribute.height + "px",
        "--indent": this.option.attribute.indent + "px",
        "--bgColor": this.option.attribute.bgColor,
        "--bgColorOption": this.option.attribute.optionBg,
        "--bgColorOptionSelect": this.option.attribute.optionSelectedBg,
        "--optionColor": this.option.attribute.optionColor,
        "--optionColorSelect": this.option.attribute.optionSelectedColor,
        "--optionFontSize": this.option.attribute.optionFontSize + "px",
        "--textColor": this.option.attribute.textColor,
        "--placholderColor": this.option.attribute.textPlaceholderColor,
        "--fontStyle": this.option.attribute.fontStyle,
        "--fontWeight": this.option.attribute.fontWeight,
        "--fontFamily": this.option.attribute.fontFamily,
        "--fontSize": this.option.attribute.fontSize + "px",
        "--borderSize": this.option.attribute.borderSize + "px",
        "--borderColor": this.option.attribute.borderColor,
        "--borderRadius": this.option.attribute.borderRadius + "px",
        "--lineType": this.option.attribute.lineType,
        "--align": this.option.attribute.align,
        "--timeIcon": this.option.attribute.timeIcon ? "block" : "none",
        "--direction": this.option.attribute.direction,
      };
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  mounted() {
    this.daterange = this.option.attribute.daterange;
    const defaultValue = getDefaultValue(
      this.option.attribute,
      "cpt-date-picker-mobile"
    );
    if (defaultValue) {
      console.log(defaultValue, "defaultValue");
      let str;
      if (Array.isArray(defaultValue)) {
        // 转换数组元素
        str = defaultValue.map((item) =>
          typeof item == "undefined" ? item : String(item)
        );
        console.log(str); // 输出: ["2024", undefined]
      }
      this.option.attribute.daterange
        ? (this.checkedValDate = str)
        : (this.checkedVal = defaultValue);
    }
    //   const defaultValue = getDefaultValue(this.option.attribute,'cpt-date-picker')
    //   // if (defaultValue) {
    //   //   let date = defaultValue.replace(/\+/g, ' ');
    //   //   let isDate = new Date(date).toString()
    //   //   if (isDate != 'Invalid Date') {
    //   //       this.checkedVal = date;
    //   //   }
    //   // }
    // }
  },
  created() {
    let vm = this;
    vm.uuid = require("uuid").v1();
    // 新增属性兼容旧代码
    const attr = this.option.attribute
    if (!attr.optionFontSize) attr.optionFontSize = 12
    if (!attr.globalDataReload) attr.globalDataReload = [0]
    if (vm.dataReload.includes(0)) {
      if(vm.option.cptDataForm.resData){
        vm.processData(vm.option.cptDataForm, vm.option.cptDataForm.resData, vm.option.cptDataForm.jsFunFlag);
      }else{
        vm.refreshCptData();
      }
    }
  },
  methods: {
    showMessage(
      theme = "info",
      content = "这是一条普通通知信息",
      duration = 5000
    ) {
      if (MobileMessage[theme]) {
        MobileMessage[theme]({
          offset: ["50%", 70],
          content,
          duration,
          icon: true,
          zIndex: 20000,
          context: document.querySelector(".t-overlay"),
        });
      }
    },
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () =>
        this.loadData(cptDataForm, paras)
      );
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.resStr
            : res; //相同数据集只调用一次接口原因
        // that.jsFunFlag =
        //   cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
        //     ? res.jsFunction
        //     : false; //相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag);
      });
    },
    processData(cptDataForm, res, jsFunFlag,isFromGrid) {
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == "4") {
            if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 

        // 第二层判断 ，如果没有配转换脚本
        if (jsFunFlag) {
              //判断此控件在九宫格里面就不请求数据
          // 没有全部配置映射字段
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            let newres = [];
            let newObj = { ...res[0] };
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            newres.push(newObj);
            this.checkedVal = newres[0].value;
          }
        } else {
          // 如果配置了转换脚本
          this.checkedVal = res.value;
        }
      } else {
        // 不是数据集类型，是静态数据
        this.checkedVal = res.value;
      }
    },
    onChange(val) {
      let vm = this;
      vm.pickerValueText = val;
    },
    cellClick(val) {
      this.active = val;
    },
    confirm() {
      let vm = this;
      const picker = vm.$refs.picker;
      picker.onConfirm(vm.pickerValueText);
    },
    onCancel() {
      this.visible = false;
    },
    formatDefaultValue(type) {
      let vm = this;
      switch (type) {
        case "year":
          return (vm.pickerValueText = new Date().toISOString().slice(0, 4));
        case "month":
          return (vm.pickerValueText = new Date().toISOString().slice(0, 7));
        case "datetime":
          return (vm.pickerValueText = new Date().toISOString().slice(0, 19));
        case "HH":
          return (vm.pickerValueText = new Date().toISOString().slice(11, 13));
        case "HH:mm":
          return (vm.pickerValueText = new Date().toISOString().slice(11, 16));
        case "HH:mm:ss":
          return (vm.pickerValueText = new Date().toISOString().slice(11, 16));
        default:
          return new Date().toISOString().slice(0, 10);
      }
    },
    formatMode(val = "data") {
      switch (val) {
        case "year":
          return "year";
        case "month":
          return "month";
        case "datetime":
          return "second";
        case "HH":
          return [null, "hour"];
        case "HH:mm":
          return [null, "minute"];
        case "HH:mm:ss":
          return [null, "second"];
        default:
          return "date";
      }
    },
    formatD(val = "data") {
      switch (val) {
        case "year":
          return "YYYY";
        case "month":
          return "YYYY-MM";
        case "datetime":
          return "YYYY-MM-DD HH:mm:ss";
        case "HH":
          return "HH";
        case "HH:mm":
          return "HH:mm";
        case "HH:mm:ss":
          return "HH:mm:ss";
        default:
          return "YYYY-MM-DD";
      }
    },
    handleConfirm(val) {
      let vm = this;
      let start = vm.daterangeData[0],
        end = vm.daterangeData[1],
        active = vm.active;
      if (active == 1) {
        vm.daterangeData[0] = val;
        if (new Date(end).getTime() < new Date(val).getTime()) {
          vm.daterangeData[1] = val;
        }
        vm.active = 2;
      } else {
        if (!start) {
          vm.daterangeData[0] = val;
        } else {
          if (new Date(val).getTime() < new Date(start).getTime()) {
            vm.$message("warning", "结束时间不能小于开始时间")
            // vm.showMessage("warning", "结束时间不能小于开始时间");
            return;
          } else {
            vm.daterangeData[1] = val;
            vm.checkedValDate = vm.daterangeData;
            vm.$emit(
              "clickHandler",
              vm.option.interaction,
              "default",
              vm.daterangeData,
              "cpt-date-picker-mobile"
            );
            vm.visible = false;
          }
        }
      }
    },
    clickHandler(val) {
      this.checkedVal = val;
      this.visible = false;
      this.$emit(
        "clickHandler",
        this.option.interaction,
        "default",
        this.checkedVal,
        "cpt-date-picker-mobile"
      );
      this.checkValue();
    },
    // 校验方法
    checkValue() {
      const { attribute } = this.option;
      console.log(this.checkedVal, "this.checkedVal");
      if (attribute.required && !this.checkedVal) {
        this.setValidationMessage(false);
        return false;
      } else {
        this.setValidationMessage(true);
        return true;
      }
    },
    setValidationMessage(isValid) {
      this.message = isValid ? "default" : "error";
      this.tips = isValid ? "" : `${this.option.attribute.label}必选`;
    },
    getValue() {
      console.log(
        this.option.attribute.daterange,
        "this.option.attribute.daterange"
      );
      if (this.option.attribute.daterange) {
        return this.checkedValDate;
      } else {
        return this.checkedVal;
      }
    },
    setValue(value) {
      console.log(value, this.option.attribute.daterange, "东山口大声道");
      if (this.option.attribute.daterange) {
        this.checkedValDate = value.split(",");
      } else {
        this.checkedVal = value;
      }
    },
  },
};
</script>
<style>
.t-popup .t-picker__cancel,
.t-popup .t-picker__confirm,
.t-popup .t-picker__title {
  font: var(--td-font-body-small);
}
.t-popup .my_daterange .t-picker__toolbar {
  height: 0 !important;
}
.t-popup .my_toolbar {
  display: flex;
  align-items: center;
  margin-top: 5px;
}
.t-popup .my_data_range {
  justify-content: center;
  height: 100%;
  display: flex;
  align-items: center;
  gap: var(--td-comp-margin-s);
  width: 100%;
}
.my_data_range .t-icon {
  color: var(--td-text-color-placeholder);
}
.t-popup .my_toolbar .my_data_range_cell {
  width: calc(var(--width) - 100px);
  background-color: var(--bgColor);
  border-width: var(--borderSize);
  border-color: var(--borderColor);
  border-radius: var(--borderRadius);
  border-style: var(--lineType);
  /* width: var(--width); */
  min-height: var(--height);
  height: var(--td-comp-size-m);
  padding: 0 var(--td-comp-paddingLR-s);
}
.t-popup .my_toolbar .my_data_range_cell .t-cell__note {
  font: var(--td-font-body-small);
  justify-content: flex-start;
}
.t-popup .my_toolbar .my_data_range .active {
  border-color: rgb(37, 137, 255);
}
.t-popup .t-date-time-picker .t-picker__toolbar {
  height: var(--td-picker-toolbar-height, 35px);
}
.t-popup .t-picker {
  background-color: var(--bgColorOption) !important;
}
.t-popup .t-picker-item__item--active {
  background-color: var(--bgColorOptionSelect) !important;
  color: var(--optionColorSelect);
}
.t-popup .t-picker__indicator {
  background-color: var(--bgColorOptionSelect);
}
.t-popup .t-picker__mask--top {
  background: var(--bgColorOption);
}
.t-popup .t-picker__mask--bottom--top {
  background: var(--bgColorOption);
}
.t-popup .t-picker-item__item {
  color: var(--optionColor);
}
.t-popup .t-picker-item__item {
  font-size: var(--optionFontSize);
}
.t-overlay .t-message {
  /* margin-left: -100px; */
}
</style>
<style scoped>
.t-form :deep(.t-form__controls){
  margin-left: 0px !important;
}
.t-form :deep(.t-form__controls-content) > div{
  width: 100%;
}
.my_date_picker_item {
  width: 100%;
  background-color: var(--bgColor);
  border-width: var(--borderSize);
  border-color: var(--borderColor);
  border-radius: var(--borderRadius);
  border-style: var(--lineType);
  /* width: var(--width); */
  min-height: var(--height);
  height: var(--td-comp-size-m);
  padding: 0 var(--td-comp-paddingLR-xs);
}
.white {
  color: var(--textColor);
  white-space: nowrap;
  word-wrap: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}
.my_data_range_item {
  height: 100%;
  display: flex;
  align-items: center;
  gap: var(--td-comp-margin-s);
  width: 100%;
  transition: color 0.2s linear;
  font-size: 16px;
  color: var(--td-text-color-placeholder);
  flex-shrink: 0;
}
.my_date_picker_item.top {
  width: calc(var(--width) - 1px);
}
.my_date_picker /deep/ .t-form__label {
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  line-height: var(--height);
}
.my_date_picker_item /deep/ .t-cell__note {
  justify-content: flex-start;
  padding-left: var(--indent);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  text-align: var(--align);
  overflow: hidden;
}
</style>
